const diffMonths = (from, to) => ((to.getFullYear() - from.getFullYear()) * 12) + (to.getMonth() - from.getMonth());

export default diffMonths;
